var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Grid',{attrs:{"col":"12","row-gap":"s"}},[_c('Form',{staticClass:"form--single form--no-accordion",attrs:{"id":"edit-subscription-address","name":_vm.$labels.shipping_address}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }